import styled from "styled-components";
import RSelect from "react-select";

export const StyledRSelect = styled(RSelect)`
  margin-top: 5px;

  & .react-select__control {
    height: 48px;
    border-radius: 8px;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    box-shadow: none;

    &:hover {
      border: 2px solid ${({ theme }) => theme.colors.primary};
    }
  }

  & .react-select__value-container {
    padding: 2px 16px;
  }

  & .react-select__single-value {
    color: ${({ theme }) => theme.colors.primary};
  }

  & .react-select__indicator-separator {
    display: none;
  }

  & .react-select__indicator {
    color: ${({ theme }) => theme.colors.primary};
    padding-right: 16px;
  }

  & .react-select__menu {
    top: 90%;
    border: 2px solid ${({ theme }) => theme.colors.primary};
    border-radius: 8px;

    & .react-select__option {
      padding: 8px 16px;
    }

    & .react-select__option:not(:last-child) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
    }

    & .react-select__option--is-focused {
      background-color: transparent;
      font-weight: ${({ theme }) => theme.fonts.weights.bold};
      text-decoration: underline;
    }

    & .react-select__option--is-selected {
      color: ${({ theme }) => theme.colors.primary};
      background-color: transparent;
    }
  }
`;
